import { render } from "./SelectComponentFerramentaAssociacaoVale.vue?vue&type=template&id=c0337f94&scoped=true"
import script from "./SelectComponentFerramentaAssociacaoVale.vue?vue&type=script&lang=js"
export * from "./SelectComponentFerramentaAssociacaoVale.vue?vue&type=script&lang=js"

import "./SelectComponentFerramentaAssociacaoVale.vue?vue&type=style&index=0&id=c0337f94&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0337f94"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QBtn,QTable,QTr,QTh,QTd,QCheckbox,QPagination});
